/**
 * The six categories, in the order the left pane lists them.
 *
 * Definitions, not components: the shell renders the list, the router resolves
 * the panel, and both read this. One array is what keeps the navigation, the
 * routes and the narrow-viewport list from drifting apart - the previous
 * single-column screen had no such thing because it had no navigation to
 * disagree with.
 *
 * **Six, not seven.** The design this follows also called for a "Dil ve Bölge"
 * category. The product speaks one language and has no locale infrastructure,
 * so that category would contain either a dropdown with one entry or a
 * sentence explaining why the dropdown is absent - the first is the placebo
 * control this screen exists to refuse, and the second is an entire category
 * built around an apology. It is left out. If the product ever gains a second
 * language, the category arrives with it.
 *
 * The order is a claim about frequency, not importance: Hesap is where people
 * arrive to change a password, and Gizlilik ve Güvenlik is where they arrive
 * deliberately.
 */

export interface SettingsCategory {
  /** URL segment under `/ayarlar`. */
  slug: string;
  label: string;
  /** One line under the label in the list. Never a restatement of the label. */
  summary: string;
}

export const SETTINGS_CATEGORIES: readonly SettingsCategory[] = [
  {
    slug: "hesap",
    label: "Hesap",
    summary: "Ad, e-posta ve parola",
  },
  {
    slug: "gorunum",
    label: "Görünüm",
    summary: "Sistem, koyu veya açık tema",
  },
  {
    slug: "cekim",
    label: "Çekim",
    summary: "Telefon bağlantısı ve desteklenen dosyalar",
  },
  {
    slug: "bildirimler",
    label: "Bildirimler",
    summary: "Hangi olaylar bildirim üretir",
  },
  {
    slug: "goruntuleyici",
    label: "3D Görüntüleyici",
    summary: "Nokta boyutu",
  },
  {
    slug: "gizlilik",
    label: "Gizlilik ve Güvenlik",
    summary: "Açık oturumlar ve tarayıcıda saklananlar",
  },
] as const;

/** Where `/ayarlar` with no category lands. */
export const DEFAULT_SETTINGS_CATEGORY = SETTINGS_CATEGORIES[0]!.slug;
